// extracted by mini-css-extract-plugin
export default {"container":"GL-z","darkBackground":"HL-z","whiteBackground":"IL-z","headerButton":"JL-z","calloutHeading":"KL-z","calloutSubHeading":"LL-z"};